import { render, staticRenderFns } from "./caseInfoBase.vue?vue&type=template&id=103556e8&scoped=true&lang=pug"
import script from "./caseInfoBase.vue?vue&type=script&lang=js"
export * from "./caseInfoBase.vue?vue&type=script&lang=js"
import style1 from "./caseInfoBase.vue?vue&type=style&index=1&id=103556e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103556e8",
  null
  
)

export default component.exports